import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@wit-support/ui';
import { ChevronDown, ChevronRight } from 'lucide-react';
/**
 * Chevron pair used by every expandable list row in the admin rail:
 * `ChevronDown` when open, `ChevronRight` when closed. Byte-identical to the
 * inline JSX in `SubscriptionActionsPanel` and `PipelineRunHistory`
 * (`inbox-page.tsx`) — both render exactly this pair.
 */
export function ExpandChevron({ expanded }) {
    return expanded ? (_jsx(ChevronDown, { className: "h-3.5 w-3.5 shrink-0 text-[var(--color-text-muted)]" })) : (_jsx(ChevronRight, { className: "h-3.5 w-3.5 shrink-0 text-[var(--color-text-muted)]" }));
}
ExpandChevron.displayName = 'ExpandChevron';
/**
 * Two-state list row (summary + optional expanding detail), extracted
 * byte-identical from `SubscriptionActionsPanel` (subscription-actions rail
 * card) and `PipelineRunHistory` (run-history rail card) — kit-extraction
 * Wave 6, task 7. Both copies share the toggle `Button`'s class and the
 * non-expandable fallback `<div>`'s class verbatim; `liClassName` and
 * `detailClassName` are where the two callers diverge, so they stay
 * per-instance props rather than being folded into one canonical class. Both
 * call sites migrated onto this component in Wave 7.
 */
export function ExpandableListRow({ expandable, expanded, onToggle, detailId, liClassName, rowBody, detail, detailClassName, }) {
    return (_jsxs("li", { className: liClassName, children: [expandable ? (_jsx(Button, { variant: "ghost", size: "sm", type: "button", "aria-expanded": expanded, "aria-controls": detailId, onClick: onToggle, className: "flex h-auto w-full flex-col items-stretch gap-1 rounded-md px-2.5 py-2 text-left font-normal hover:bg-[var(--color-surface-sunken)]", children: rowBody })) : (_jsx("div", { className: "flex flex-col items-stretch gap-1 rounded-md px-2.5 py-2", children: rowBody })), expanded ? (_jsx("div", { id: detailId, className: detailClassName, children: detail })) : null] }));
}
ExpandableListRow.displayName = 'ExpandableListRow';
//# sourceMappingURL=expandable-list-row.js.map